"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var paymentPageStyles = makeStyles_1.default(function () { return ({
    container: {},
}); }, { name: 'Checkout4_PaymentPage' });
exports.default = paymentPageStyles;
